<template>
    <div>
        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <h5 class="font-weight-bold">Tanda-Tanda Vital</h5>
                <b-row>
                    <b-col md="6" lg="6">
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label font-weight-bold">Tinggi Badan</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.tinggi_badan ? dataRM.anamnesa.tinggi_badan : '-' }} cm
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label font-weight-bold">Berat Badan</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.berat_badan ? dataRM.anamnesa.berat_badan : '-' }} kg
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label font-weight-bold">Suhu</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.suhu ? dataRM.anamnesa.suhu : '-' }} c
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label font-weight-bold">Sistole</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.tensi_sistole ? dataRM.anamnesa.tensi_sistole : '-' }} mmHg
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label font-weight-bold">Diastole</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.tensi_diastole ? dataRM.anamnesa.tensi_diastole : '-' }} mmHg
                            </div>
                        </div>
                    </b-col>
                    <b-col md="6" lg="6">
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label font-weight-bold">Nadi</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.nadi ? dataRM.anamnesa.nadi : '-' }} x/menit
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label font-weight-bold">Respirasi</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.respirasi ? dataRM.anamnesa.respirasi : '-' }} x/menit
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label font-weight-bold">Lingkar Perut</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.lingkar_perut ? dataRM.anamnesa.lingkar_perut : '-' }} cm
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label font-weight-bold">IMT</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.imt ? dataRM.anamnesa.imt : '-' }} kg/m2
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label font-weight-bold">Saturasi Oksigen</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.saturasi_oksigen ? dataRM.anamnesa.saturasi_oksigen : '-' }} %
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>
        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <h5>Pemeriksaan Fisik</h5>
                <b-row class="mt-5" v-show="kategoriPasien == 2">
                    <b-col lg="12" md="12">
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-3 col-form-label"> Kesadaran</label>
                            <div class="col-sm-9 form-control-plaintext">
                                <strong>{{
                                    dataRM.bpjs_nmSadar || "-"
                                }}</strong>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col lg="12" md="12">
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-3 col-form-label">Tingkat Kesadaran</label>
                            <div class="col-sm-9 form-control-plaintext">
                                <strong>{{
                                    dataRM.pemeriksaan_fisik.tingkat_kesadaran || "-"
                                }}</strong>
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <b-row class="mt-5">
                    <b-col lg="6" md="6">
                        <b-img v-bind:src="drawPathFisik" fluid></b-img>
                    </b-col>
                    <b-col lg="6" md="6">
                        <div v-html="this.dataRM.pemeriksaan_fisik.notes"></div>
                    </b-col>
                </b-row>
            </div>
        </div>

        <div class="card card-box mb-3" v-if="poliGigi">
            <div class="card-body p-4">
                <h5>Odontogram</h5>
                <b-row class="mt-5">
                <b-col lg="12" md="12" class="text-center">
                    <b-img v-bind:src="drawPathGigi"></b-img>
                </b-col>
                <b-col lg="12" md="12">
                    <label for="kondisi-gigi" class="font-weight-bold">Catatan:</label>
                    <div v-html="checkValueData(dataRM.odontogram.notes) ? dataRM.odontogram.notes : '-'"></div>
                </b-col>
                </b-row>

                <div class="row mt-4">
                    <div class="col-md-12 media">
                        <div class="media-body">
                            <label for="kondisi-gigi" class="font-weight-bold">Kondisi Gigi</label>
                        </div>
                    </div>
                    <div class="col-md-12 table-responsive mt-3">
                        <b-table
                            :fixed="true"
                            :items="listConditionGigi"
                            :fields="fieldListGigi"
                            :borderless="true"
                            class="custom_border"
                        >
                            <template v-slot:cell()="data">
                                <p v-if="data.item.is_blank">&nbsp;</p>
                                <p v-else>{{ checkValueData(data.value) ? data.value : '-' }}</p>
                            </template>
                            <template v-slot:cell(icdx)="data">
                                <p v-for="(v, i) in data.item.icdx" :key="i">{{ checkValueData(v) ? v : '-' }}</p>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
        </div>

        <div class="card card-box mb-3" v-if="poliGigi">
            <div class="card-body p-4">
                <div class="row">
                    <div class="col-md-5">
                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Occlusi</div>
                            <div class="col-md-6">{{ dataRM.odontogram.occlusi || '-' }}</div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Torus Palatinus</div>
                            <div class="col-md-6">{{ dataRM.odontogram.torus_palatinus || '-' }}</div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Torus Mandibularis</div>
                            <div class="col-md-6">{{ dataRM.odontogram.torus_mandibularis || '-' }}</div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Palatum</div>
                            <div class="col-md-6">{{ dataRM.odontogram.palatum || '-' }}</div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Diastema</div>
                            <div class="col-md-6">{{ convertDataGigi(dataRM.odontogram.diastema, dataRM.odontogram.ket_diastema, ',') }}</div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Jumlah photo yang diambil</div>
                            <div class="col-md-6">{{ convertDataGigi(dataRM.odontogram.qty_photo, dataRM.odontogram.satuan_photo) }}</div>
                        </div>
                    </div>
                    <div class="col-md-7">
                        <div class="row mb-4">
                            <div class="col-md-5 font-weight-bold">Gigi Anomali</div>
                            <div class="col-md-7">{{ convertDataGigi(dataRM.odontogram.gigi_anomali, dataRM.odontogram.ket_gigi_anomali, ',') }}</div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-md-5 font-weight-bold">Lain - Lain</div>
                            <div class="col-md-7">{{ dataRM.odontogram.lain_lain || '-' }}</div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-md-5 font-weight-bold">Decay</div>
                            <div class="col-md-7">{{ dataRM.odontogram.d || '-' }}</div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-md-5 font-weight-bold">Missing</div>
                            <div class="col-md-7">{{ dataRM.odontogram.m || '-' }}</div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-md-5 font-weight-bold">Filling</div>
                            <div class="col-md-7">{{ dataRM.odontogram.f || '-' }}</div>
                        </div>
                        <div class="row mb-4">
                            <div class="col-md-5 font-weight-bold">Jumlah rontgen photo yang diambil</div>
                            <div class="col-md-7">{{ convertDataGigi(dataRM.odontogram.qty_rontgen, dataRM.odontogram.satuan_rontgen) }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <div class="row">
                    <div class="col-md-4">
                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Luas Permukaan Tubuh Untuk Anak-Anak</div>
                            <div class="col-md-6">{{ dataRM.pemeriksaan_fisik.luas_fisik || '-' }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Kepala</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.kepala, dataRM.pemeriksaan_fisik.ket_kepala) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Mata</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.mata, dataRM.pemeriksaan_fisik.ket_mata) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Telinga</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.telinga, dataRM.pemeriksaan_fisik.ket_telinga) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Hidung</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.hidung, dataRM.pemeriksaan_fisik.ket_hidung) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Rambut</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.rambut, dataRM.pemeriksaan_fisik.ket_rambut) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Bibir</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.bibir, dataRM.pemeriksaan_fisik.ket_bibir) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Gigi Geligi</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.gigi_geligi, dataRM.pemeriksaan_fisik.ket_gigi_geligi) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Lidah</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.lidah, dataRM.pemeriksaan_fisik.ket_lidah) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Langit-Langit</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.langit_langit, dataRM.pemeriksaan_fisik.ket_langit_langit) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Leher</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.leher, dataRM.pemeriksaan_fisik.ket_leher) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Tenggorokan</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.tenggorokan, dataRM.pemeriksaan_fisik.ket_tenggorokan) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Tonsil</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.tonsil, dataRM.pemeriksaan_fisik.ket_tonsil) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Dada</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.dada, dataRM.pemeriksaan_fisik.ket_dada) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Payudara</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.payudara, dataRM.pemeriksaan_fisik.ket_payudara) }}</div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Punggung</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.punggung, dataRM.pemeriksaan_fisik.ket_punggung) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Perut</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.perut, dataRM.pemeriksaan_fisik.ket_perut) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Genital</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.genital, dataRM.pemeriksaan_fisik.ket_genital) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Anus/Dubur</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.anus, dataRM.pemeriksaan_fisik.ket_anus) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Lengan Atas</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.lengan_atas, dataRM.pemeriksaan_fisik.ket_lengan_atas) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Lengan Bawah</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.lengan_bawah, dataRM.pemeriksaan_fisik.ket_lengan_bawah) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Jari Tengah</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.jari_tangan, dataRM.pemeriksaan_fisik.ket_jari_tangan) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Kuku Tangan</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.kuku_tangan, dataRM.pemeriksaan_fisik.ket_kuku_tangan) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Persendian Tangan</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.persendian_tangan, dataRM.pemeriksaan_fisik.ket_persendian_tangan) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Tungkai Atas</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.tungkai_atas, dataRM.pemeriksaan_fisik.ket_tungkai_atas) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Tungkai Bawah</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.tungkai_bawah, dataRM.pemeriksaan_fisik.ket_tungkai_bawah) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Jari Kaki</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.jari_kaki, dataRM.pemeriksaan_fisik.ket_jari_kaki) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Kuku Kaki</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.kuku_kaki, dataRM.pemeriksaan_fisik.ket_kuku_kaki) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Persendian Kaki</div>
                            <div class="col-md-6">{{ convertData(dataRM.pemeriksaan_fisik.persendian_kaki, dataRM.pemeriksaan_fisik.ket_persendian_kaki) }}</div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Status Psikologis</div>
                            <div class="col-md-6">{{ getStatusPsikologis(dataRM.pemeriksaan_fisik.status_psikologis) }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Sosial Ekonomi</div>
                            <div class="col-md-6">{{ dataRM.pemeriksaan_fisik.sosial_ekonomi || '-' }}</div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-6 font-weight-bold">Spiritual</div>
                            <div class="col-md-6">{{ dataRM.pemeriksaan_fisik.spiritual || '-' }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <b-row>
                    <b-col md="12" lg="12">
                      <h5 class="font-weight-bold">Pemeriksaan Penunjang</h5>
                    </b-col>
                    <b-col md="12" lg="12" v-for="items in dataMCU" :key="items.id">
                        <b-row>
                          <b-col sm="4">Jenis Pemeriksaan Penunjang</b-col>
                          <b-col sm="8" class="font-weight-bold" v-if="items.selectedJenis && items.selectedJenis.value == 'pemeriksaanLain'">
                            {{items.jenis_lain}}
                          </b-col>
                          <b-col sm="8" class="font-weight-bold" v-else>
                            {{items.selectedJenis && items.selectedJenis.label}}
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col sm="4">Hasil</b-col>
                          <b-col sm="8">
                            <template v-if="items.selectedJenis && items.selectedJenis.value == 'radiologiFoto'">
                                <img :src="items.hasil.url" class="img-fluid" alt="img" />
                            </template>
                            <template v-else>
                                {{items.hasil}}
                            </template>
                          </b-col>
                        </b-row>
                        <hr/>
                    </b-col>
                    <b-col md="12" lg="12">
                        <h6 class="mt-3">Uploaded file:</h6>
                        <div>
                            <template v-if="datafile.length > 0">
                                <b-row v-for="items in datafile" :key="items.id">
                                  <b-col sm="4">{{ items.name }}</b-col>
                                  <b-col sm="8">
                                    <font-awesome-icon class="align-middle"
                                        style="color:#3b3e66;padding:5px;font-size:1.7em;"
                                        @click="downloadImage(items, 'download')" icon="download" />
                                    <font-awesome-icon class="align-middle"
                                        style="color:#3b3e66;padding:5px;font-size:1.7em;"
                                        @click.prevent="downloadImage(items, 'preview')" icon="eye" />
                                  </b-col>
                                </b-row>
                            </template>
                            <template v-else>
                                <span>-</span>
                            </template>
                        </div>
                    </b-col>
                    <b-col md="12" lg="12">
                        <b-row>
                          <b-col sm="4">Keterangan</b-col>
                          <b-col sm="8">
                            <div v-html="dataRM.pemeriksaan_penunjang.notes"></div>
                          </b-col>
                        </b-row>
                    </b-col>
                    <b-col md="12" lg="12">
                        <template v-if="dataRM.pemeriksaan_penunjang.draw_path !== null">
                            <img :src="dataRM.pemeriksaan_penunjang.draw_path" class="img-fluid" alt="img" />
                        </template>
                    </b-col>
                </b-row>
            </div>
        </div>

        <b-modal size="xl" ref="show-penunjang-doc" class="modal-backdrop" hide-footer scrollable title="Preview Dokumen">
            <div class="d-block text-center" style="height: 100%">
                <img :src="previewFile" class="img-fluid"
                    v-show="/jpg|jpeg|jfif|pjpeg|pjp|png|svg|webp|giff/.test(previewFile)" alt="preview-document">
                <iframe style="height:100%;width:100%" :src="previewFile" v-show="/pdf/.test(previewFile)" frameBorder="0"
                    scrolling="auto" height="100%" width="100%"></iframe>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import rekamMedisMixin from "../mixins";
    import { library } from "@fortawesome/fontawesome-svg-core";
    import { faFile, faDownload, faEye } from "@fortawesome/free-solid-svg-icons";
    
    library.add(faFile, faDownload, faEye);

    export default {
        name: "Objective",
        mixins: [rekamMedisMixin],
        props: ["dataRM", "poliGigi"],
        data() {
            return {
                drawPathGigi: null,
                listConditionGigi: [
                {
                    id: null,
                    no_gigi: null,
                    bagian: null,
                    kondisi: null,
                    icd_x: [],
                    keterangan: null,
                    is_blank: true,
                }
                ],
                permukaanGigi: [
                    { value: 'all', label: 'Semua' },
                    { value: 'M', label: 'M - Messial' },
                    { value: 'O', label: 'O - Occlusal' },
                    { value: 'D', label: 'D - Distal' },
                    { value: 'V', label: 'V - Vestibular/Bukal/Labial' },
                    { value: 'L', label: 'L - Lingual/Palatal' },
                ],
                drawPathFisik: null,
                kategoriPasien: null,
                kodeSadar: [
                    {
                        kdSadar: "01",
                        nmSadar: "Compos mentis"
                    },
                    {
                        kdSadar: "02",
                        nmSadar: "Somnolence"
                    },
                    {
                        kdSadar: "03",
                        nmSadar: "Sopor"
                    },
                    {
                        kdSadar: "04",
                        nmSadar: "Coma"
                    }
                ],
                kesadaran: null,
                datafile: [],
                previewFile: null,
                dataMCU: [],
            }
        },
        computed: {
            ...mapGetters(["getKlinikId"]),
            fieldListGigi() {
                return (
                    [
                        {
                            key: 'no_gigi',
                            label: 'no gigi',
                            thClass: 'head-custom',
                            stickyColumn: true,
                            isRowHeader: true,
                        },
                        {
                            key: 'bagian',
                            label: 'bagian',
                            thClass: 'head-custom',
                        },
                        {
                            key: 'kondisi',
                            label: 'kondisi',
                            thClass: 'head-custom',
                        },
                        {
                            key: 'icdx',
                            label: 'icd 10',
                            thClass: 'head-custom',
                        },
                        {
                            key: 'keterangan',
                            label: 'keterangan tambahan',
                            thClass: 'head-custom',
                        },
                    ]
                )
            },
        },
        watch: {
            dataRM() {
                this.buildData();
            }
        },
        mounted() {
            this.buildData();
        },
        methods: {
            buildData() {
                if (this.dataRM) {
                    if (this.poliGigi) {
                        if (this.checkValueData(this.dataRM.odontogram) && this.checkValueData(this.dataRM.odontogram.draw_path)) this.drawPathGigi = this.dataRM.odontogram.draw_path;
                        else this.drawPathGigi = 'https://fs.izidok.id/izidok/odontogram/odontogram-20240313120342-115619585.png';

                        if (this.dataRM.odontogram_table) {
                            this.listConditionGigi = this.dataRM.odontogram_table.map(d => {
                                let pg = this.permukaanGigi.find(pg => pg.value == d.permukaan_gigi);
                                return {
                                    ...d,
                                    bagian: pg ? pg.label : '-',
                                    kondisi: this.setKondisi(d),
                                    icdx: d.icd_x.length > 0 ? d.icd_x.map(icd => `${icd.kode} - ${icd.description}`): '-',
                                    is_blank: false,
                                }
                            });
                        }
                    }

                    this.datafile = []
                    this.dataMCU = []
                    if (this.dataRM.bpjs_mcu.data && this.dataRM.bpjs_mcu.data.length > 0) {
                      this.dataMCU = this.dataRM.bpjs_mcu.data
                      let radiologi = this.dataRM.bpjs_mcu.data.find(item => item.selectedJenis && item.selectedJenis.value == 'radiologiFoto')
                      if (radiologi) {
                        this.datafile.push(radiologi.hasil)
                      }
                    }

                    if (this.dataRM.pemeriksaan_penunjang.files !== 'null') {
                      this.datafile = this.datafile.concat(JSON.parse(this.dataRM.pemeriksaan_penunjang.files));
                    }

                    this.kategoriPasien = this.dataRM.transklinik.kategori_id
                    this.drawPathFisik = this.dataRM.pemeriksaan_fisik.draw_path;

                    if (this.kategoriPasien == 2) {
                        this.kesadaran = this.kodeSadar.find((({ kdSadar }) => kdSadar == this.dataRM.bpjs_kdSadar))
                    }
                }
            },
            setKondisi(data) {
                let kondisi = [];
                if (data.keadaan_gigi.length > 0) kondisi = [...kondisi, ...data.keadaan_gigi];
                if (data.bahan_restorasi.length > 0) kondisi = [...kondisi, ...data.bahan_restorasi];
                if (data.restorasi.length > 0) kondisi = [...kondisi, ...data.restorasi];
                if (data.protesa.length > 0) kondisi = [...kondisi, ...data.protesa];
                return kondisi.length > 0 ? kondisi.join(' - ') : '-';
            },
            getStatusPsikologis(status) {
                const statusMapping = {
                    N: "Tidak Ada Kelainan",
                    C: "Cemas",
                    T: "Takut",
                    M: "Marah",
                    S: "Sedih",
                    L: `Lain-Lain, ${this.dataRM.pemeriksaan_fisik.ket_status_psikologis}` 
                };

                return statusMapping[status] || "-";
            },
            convertData(status, content){
                if(status == 'T'){
                    return 'Tidak Ada Kelainan'
                }

                if(status == 'Y'){
                    return `Ada Kelainan, ${content}`
                }

                if(status == 'N'){
                    return `Tidak Diperiksa`
                }
                return '-'
            },
            convertDataGigi(val, ket, coma = '') {
                let result = '';
                if (this.checkValueData(val)) {
                    result += val;
                    if (this.checkValueData(ket)) result += `${coma} ${ket}`;
                } else {
                    result = '-';
                }
                return result;
            },
            async downloadImage(item, type) {
                if (type == 'download') {
                    let fileName = this.getPureName(item.name);
                    const a = document.createElement("a");
                    a.href = await this.toDataURL(item.url);
                    a.download = Object.values(fileName).join(".");
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                } else {
                    this.previewFile = item.url;
                    this.$refs['show-penunjang-doc'].show();
                }
            },
            getPureName(raw) {
                let extIndex = raw.lastIndexOf('_');
                let name = raw.slice(0, extIndex);
                return {
                    name: name.replace(/[-_]/g, ' '),
                    ext: raw.slice(extIndex + 1)
                }
            },
            toDataURL(url) {
                return fetch(url).then((response) => {
                    return response.blob();
                }).then(blob => {
                    return URL.createObjectURL(blob);
                });
            },
        }
    }
</script>

<style>
    .mb-header {
        margin-bottom: -15px;
    }
    .custom_border {
        border: 2px solid #eee;
        border-radius: 5px;
    }
    .custom_border td, .custom_border th {
        vertical-align: top;
    }
</style>